// routes which require authentication
import authRoutesAwards from '@/router/routes-awards';

const authRoutes = [
  {
    path: '/',
    name: 'Dashboard',
    meta: {
      title: 'Dashboard',
    },
    component: () => import(/* webpackChunkName: "dashboard-index" */ '../views/areas/dashboard/Index.vue'),
  },

  {
    path: '/grid',
    name: 'Grid',
    meta: {
      title: 'Grid demo',
    },
    component: () => import(/* webpackChunkName: "users" */ '../views/areas/demo/Grid.vue'),
  },

  {
    path: '/users',
    name: 'AdminUsers',
    meta: {
      title: 'Admins',
    },
    component: () => import(/* webpackChunkName: "users" */ '../views/areas/users/Index.vue'),
  },

  {
    path: '/users/create',
    name: 'AdminUsersCreate',
    meta: {
      title: 'Admins - create new user',
      breadcrumbParent: {
        name: 'AdminUsers',
        text: 'Admins',
      },
    },
    component: () => import(/* webpackChunkName: "users" */ '@/views/areas/users/Create.vue'),
  },

  {
    path: '/users/:id',
    name: 'AdminUsersEdit',
    meta: {
      title: 'Admins - edit user',
      breadcrumbParent: {
        name: 'AdminUsers',
        text: 'Admins',
      },
    },
    component: () => import(/* webpackChunkName: "users" */ '@/views/areas/users/Edit.vue'),
  },

  {
    path: '/affiliates',
    name: 'Affiliates',
    meta: {
      title: 'Affiliates',
    },
    component: () => import(/* webpackChunkName: "affiliates-index" */ '../views/areas/affiliates/Index.vue'),
  },

  {
    path: '/affiliates/officials',
    name: 'AffiliatesOfficials',
    meta: {
      title: 'IFAC Officials',
      breadcrumbParent: {
        name: 'Affiliates',
        text: 'Affiliates',
      },
    },
    component: () => import(/* webpackChunkName: "affiliates-officials" */ '../views/areas/affiliates/Officials.vue'),
  },

  {
    path: '/affiliates/senior-member',
    name: 'AffiliatesSeniorMember',
    meta: {
      title: 'Promotion to Senior Member',
      breadcrumbParent: {
        name: 'Affiliates',
        text: 'Affiliates',
      },
    },
    component: () => import(/* webpackChunkName: "affiliates-senior-member" */ '../views/areas/tc-membership/senior-member/Index.vue'),
  },

  {
    path: '/affiliates/member-nominations',
    name: 'AffiliatesMemberNominations',
    meta: {
      title: 'TC Member Nominations',
      breadcrumbParent: {
        name: 'Affiliates',
        text: 'Affiliates',
      },
    },
    component: () => import(/* webpackChunkName: "affiliates-member-nominations" */ '../views/areas/tc-membership/member-nominations/Index.vue'),
  },

  {
    path: '/affiliates/:id',
    name: 'AffiliatesView',
    meta: {
      title: 'Affiliates - details',
      breadcrumbParent: {
        name: 'Affiliates',
        text: 'Affiliates',
      },
    },
    component: () => import(/* webpackChunkName: "affiliates-view" */ '../views/areas/affiliates/View.vue'),
  },

  {
    path: '/affiliates/:id/edit',
    name: 'AffiliatesEdit',
    meta: {
      title: 'Affiliates - edit',
      breadcrumbParent: {
        name: 'Affiliates',
        text: 'Affiliates',
      },
    },
    component: () => import(/* webpackChunkName: "affiliates-edit" */ '../views/areas/affiliates/Edit.vue'),
  },

  {
    path: '/affiliates/:id/merge/:mergeId',
    name: 'AffiliatesMerge',
    meta: {
      title: 'Affiliates - Merge',
      breadcrumbParent: {
        name: 'Affiliates',
        text: 'Affiliates',
      },
    },
    component: () => import(/* webpackChunkName: "affiliates-edit" */ '../views/areas/affiliates/Merge.vue'),
  },

  {
    path: '/mos',
    name: 'MOs',
    meta: {
      title: 'MOs',
    },
    component: () => import(/* webpackChunkName: "mos-index" */ '../views/areas/mos/Index.vue'),
  },

  {
    path: '/technical-areas',
    name: 'TechnicalAreas',
    meta: {
      title: 'Technical Areas',
    },
    component: () => import(/* webpackChunkName: "technical-areas-index" */ '../views/areas/technical-areas/Index.vue'),
  },

  {
    path: '/mos/create',
    name: 'MosCreate',
    meta: {
      title: 'MOs - Create',
      breadcrumbParent: {
        name: 'MOs',
        text: 'MOs',
      },
    },
    component: () => import(/* webpackChunkName: "mos-create" */ '../views/areas/mos/Create.vue'),
  },

  {
    path: '/mos/:id/edit',
    name: 'MosEdit',
    meta: {
      title: 'MOs - Edit',
      breadcrumbParent: {
        name: 'MOs',
        text: 'MOs',
      },
    },
    component: () => import(/* webpackChunkName: "mos-edit" */ '../views/areas/mos/Edit.vue'),
  },

  {
    path: '/settings',
    name: 'Settings',
    meta: {
      title: 'Settings',
    },
    component: () => import(/* webpackChunkName: "settings-index" */ '../views/areas/settings/Index.vue'),
  },

  {
    path: '/email-logs',
    name: 'EmailLogs',
    meta: {
      title: 'Email Log',
    },
    component: () => import(/* webpackChunkName: "email-logs-index" */ '../views/areas/email-logs/Index.vue'),
  },

  {
    path: '/conferences',
    name: 'Conferences',
    meta: {
      title: 'Conferences',
    },
    component: () => import(/* webpackChunkName: "conferences-index" */ '../views/areas/conferences/Index.vue'),
  },

  {
    path: '/conferences/:id/overview',
    name: 'ConferencesOverview',
    meta: {
      title: 'Conferences - overview',
      breadcrumbParent: {
        name: 'Conferences',
        text: 'Conferences',
      },
    },
    component: () => import(/* webpackChunkName: "conferences-overview" */ '../views/areas/conferences/Overview.vue'),
  },

  {
    path: '/conferences/:id/details',
    name: 'ConferencesDetails',
    meta: {
      title: 'Conferences - details',
      breadcrumbParent: {
        name: 'ConferencesOverview',
        text: 'Conferences - overview',
      },
    },
    component: () => import(/* webpackChunkName: "conferences-details" */ '../views/areas/conferences/Details.vue'),
  },

  {
    path: '/conferences/:id/reports/:reportId',
    name: 'ConferencesReport',
    component: () => import(/* webpackChunkName: "conferences-report" */ '../views/areas/reports/Edit.vue'),
    meta: {
      breadcrumbParent: {
        name: 'ConferencesOverview',
        text: 'Conferences - overview',
      },
    },
  },

  {
    path: '/conferences/:id/approvals/:approvalId',
    name: 'ApprovalsDetails',
    component: () => import(/* webpackChunkName: "approvals-edit" */ '../views/areas/approvals/Details.vue'),
    meta: {
      breadcrumbParent: {
        name: 'ConferencesOverview',
        text: 'Conferences - overview',
      },
    },
  },

];

// routes which don't require authentication
const guestRoutes = [
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: function maintenancePageRoute() {
      return import(/* webpackChunkName: "maintenance-page" */ '@/views/pages/Maintenance.vue');
    },
  },
];

export default function buildRoutes({ authGuard, guestGuard }) {
  return [
    ...authGuard(authRoutes),
    ...authGuard(authRoutesAwards),
    ...guestGuard(guestRoutes),
  ];
}
